import React, { useEffect } from "react";
import LinkedInSvg from "../assets/images/svg/linkedin-svg.svg";
import GitHubSvg from "../assets/images/svg/github-svg.svg";

const Contact = () => {
  useEffect(() => {
    const inputs = document.querySelectorAll("input");

    const handlers = new Map();

    inputs.forEach((input) => {
      const onFocus = () => {
        input.parentElement?.classList.add("active");
      };

      const onFocusOut = () => {
        if (input.value === "") {
          input.parentElement?.classList.remove("active");
        } else {
          input.parentElement?.classList.add("active");
        }
      };

      handlers.set(input, { onFocus, onFocusOut });
      input.addEventListener("focus", onFocus);
      input.addEventListener("focusout", onFocusOut);
    });

    return () => {
      inputs.forEach((input) => {
        const handler = handlers.get(input);
        if (!handler) return;
        input.removeEventListener("focus", handler.onFocus);
        input.removeEventListener("focusout", handler.onFocusOut);
      });
    };
  }, []);

  return (
    <>
      {/* <!-- ====================================== Section Contact ===================================== --> */}
      <section className="contact-section pt-5" id="contact">
        <div className="heading-container">
          <h2 className="section-heading-text coding-skill-text fade_up">
            Get In Touch.
          </h2>
          <div className="line"></div>
        </div>
        <p className="services-product-text fade_up">
          TAKE A COFFEE & CHAT WITH ME
        </p>
        <div className="main-box-contact">
          <div className="contact-box-main zoom_in">
            <div className="mobile-icon-main">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
              >
                <path
                  d="M6 6H42C43.1046 6 44 6.89544 44 8V40C44 41.1046 43.1046 42 42 42H6C4.89544 42 4 41.1046 4 40V8C4 6.89544 4.89544 6 6 6ZM24.1212 23.3658L11.2944 12.4754L8.70556 15.5246L24.1462 28.6342L39.3088 15.5123L36.6912 12.4877L24.1212 23.3658Z"
                  fill="white"
                />
              </svg>
            </div>
            <div>
              <p className="contact-email-text">EMAIL</p>
              <p className="contact-email">
                <a href="mailto:zdnrsk@gmail.com">zdnrsk@gmail.com</a>
              </p>
            </div>
          </div>
          <div className="contact-box-main zoom_in">
            <div className="mobile-icon-main">
              <img src={LinkedInSvg} alt="linkedin" width="28" height="28" />
            </div>
            <div>
              <p className="contact-email-text">LINKEDIN</p>
              <p className="contact-email">
                <a
                  href="https://linkedin.com/in/zaidan-r-876319118"
                  target="_blank"
                  rel="noreferrer"
                >
                  Zaidan Riski
                </a>
              </p>
            </div>
          </div>
          <div className="contact-box-main zoom_in">
            <div className="mobile-icon-main">
              <img src={GitHubSvg} alt="github" width="28" height="28" />
            </div>
            <div>
              <p className="contact-email-text">GITHUB</p>
              <p className="contact-email">
                <a
                  href="https://github.com/zaidanriski"
                  target="_blank"
                  rel="noreferrer"
                >
                  zaidanriski
                </a>
              </p>
            </div>
          </div>
        </div>
        <div className="footer">
          © 2026 | All rights reserved by
          <span>
            <a href="https://devzai.net" target="_blank" rel="noreferrer">
              Zaidan Riski
            </a>
          </span>
        </div>
      </section>
      {/* <!-- ====================================== Section Contact End ===================================== --> */}
    </>
  );
};
export default Contact;
